import * as R from 'ramda';
import { FetcherResponse } from '../../../../../../components/Hooks/useList.types';
import { Message } from '../../../../contexts/chatSocket/reducer/chatSocketReducer.types';
import MessageIncrementer from '../../utils/MessageIncrementer';
import {
  ChatMessageAcceptedMessageTypesToFilter,
  ChatMessageViewEnum,
  ChatMessagesActions,
  ChatMessagesState,
} from './chatMessages.state.types';

export const getChatMessagesInitialState = (
  filterMessagesOfType?: ChatMessageAcceptedMessageTypesToFilter,
): ChatMessagesState => ({
  view: ChatMessageViewEnum.CHAT_MESSAGES,
  page: 0,
  messages: [],
  totalItems: 0,
  hasMore: false,
  error: undefined,
  isLoading: false,
  firstItemIndex: 0,
  filterMessagesOfType,
});

export const chatMessagesReducer = (
  state: ChatMessagesState,
  action: ChatMessagesActions,
): ChatMessagesState => {
  switch (action.type) {
    case 'FETCHING_MORE':
      return {
        ...state,
        isLoading: true,
      };

    case 'FETCH_MESSAGES_RESULT': {
      const response: FetcherResponse<Message> = action.payload;

      if (response.tag === 'error') {
        return {
          ...state,
          isLoading: false,
          messages: [],
          error: response.error,
        };
      }

      const messages = R.uniqBy(
        (message) => message.id,
        [...R.reverse(response.data), ...state.messages],
      );
      const totalItems = response.count;

      const isFirstPage = state.page === 0;
      // TODO: MELHORAR ESSA LÓGICA, O TERNÁRIO PARA VALIDAÇÃO SE <0 É
      const firstItemIndex = isFirstPage
        ? totalItems - response.data.length
        : state.firstItemIndex - response.data.length;

      return {
        ...state,
        messages,
        totalItems,
        hasMore: messages.length < response.count,
        firstItemIndex: firstItemIndex < 0 ? 0 : firstItemIndex,
        page: state.page + 1,
        isLoading: false,
      };
    }

    case 'INCREMENT_NEW_WS_MESSAGE': {
      const { message } = action.payload;

      if (state.filterMessagesOfType && message.type !== state.filterMessagesOfType) {
        return state;
      }

      const messages: Message[] = MessageIncrementer.getNewMessages(message, state.messages);
      const diffToCount = messages.length - state.messages.length;
      return {
        ...state,
        messages,
        totalItems: state.totalItems + diffToCount,
      };
    }

    case 'REMOVE_WS_MESSAGE': {
      const { messageTemporaryId } = action.payload;
      const messages: Message[] = state.messages.filter(
        ({ tempId }) => tempId !== messageTemporaryId,
      );
      return {
        ...state,
        messages,
        totalItems: state.totalItems - 1,
      };
    }

    case 'GO_TO_CHAT': {
      return {
        ...state,
        view: ChatMessageViewEnum.CHAT_MESSAGES,
      };
    }

    case 'GO_TO_EDIT_CHAT': {
      return {
        ...state,
        view: ChatMessageViewEnum.EDIT_CHAT,
      };
    }

    case 'SET_MESSAGES_FILTER_BY': {
      const { filterBy } = action.payload;

      if (state.filterMessagesOfType === filterBy) {
        return state;
      }

      const newState = getChatMessagesInitialState(filterBy);
      return newState;
    }

    default:
      throw new Error('Ação do reducer não encontrada');
  }
};
